import Vue from 'vue';
import LoveAndHate from './LoveAndHate.vue';

Vue.config.productionTip = false;

var elements = document.querySelectorAll('.joomla-script-options');
if (elements.length > 0) {
  var options = JSON.parse(elements[0].text || elements[0].textContent);
  options.modules.forEach((module) => {
    if (module.name === 'LoveAndHate') {
      new Vue({
        el: module.options.selector,
        render: function(createElement) {
          return createElement(LoveAndHate, {
            props: {
              options: module.options
            }
          });
        }
      });
    }
  });
}
